module.exports = __webpack_public_path__ + "img/ch43.8e65b471.jpg";